import { memo } from 'react';

/**
 * Loading skeleton: three placeholder cards with shimmer.
 *
 * The mobile-app uses RN's `Animated.Value` to drive a 0.3 → 0.7 opacity
 * loop. On the web we get the same look from Tailwind's `animate-pulse`.
 *
 * I colori vengono dai TOKEN, non da esadecimali scritti a mano. Prima erano
 * `#1e1e1e` / `#2a2a2a`: grigi neutri, invisibili al motore dei temi, quindi
 * quando la palette e' passata al verde acqua questa schermata e' rimasta
 * l'unica grigia — e proprio quella che l'utente vede per prima, mentre
 * aspetta. Un colore scritto a mano e' un colore che non seguira' mai un
 * cambio di tema.
 */
function SkeletonCard() {
  return (
    <div className="card-edge mx-4 mb-3 overflow-hidden rounded-2xl bg-bg-secondary">
      <div className="h-[200px] w-full animate-pulse bg-bg-tertiary" />
      <div className="p-4">
        <div className="mb-2 h-[18px] w-[60px] animate-pulse rounded-[10px] bg-bg-tertiary" />
        <div className="mb-1.5 h-[18px] w-[90%] animate-pulse rounded bg-bg-tertiary" />
        <div className="mb-2 h-[18px] w-[65%] animate-pulse rounded bg-bg-tertiary" />
        <div className="mb-1 h-[14px] w-full animate-pulse rounded bg-bg-tertiary" />
        <div className="mb-2.5 h-[14px] w-[75%] animate-pulse rounded bg-bg-tertiary" />
        <div className="flex gap-3">
          <div className="h-3 w-10 animate-pulse rounded bg-bg-tertiary" />
          <div className="h-3 w-10 animate-pulse rounded bg-bg-tertiary" />
          <div className="h-3 w-10 animate-pulse rounded bg-bg-tertiary" />
        </div>
      </div>
    </div>
  );
}

export const FeedSkeleton = memo(function FeedSkeleton() {
  return (
    <div className="pt-5">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
});
